module.exports = __webpack_public_path__ + "img/phone.c55a5d57.png";